<template>
  <div>
    <vs-prompt
      title="Select category to add"
      @cancel="val = ''"
      @accept="accept"
      :active.sync="prompt"
      accept-text="Add category"
      :is-valid="validForm"
      class="add-category-popup"
    >
      <vs-select v-model="selectedCategory" class="w-full">
        <vs-select-item
          v-for="category in filteredCategories"
          :key="category.productCategoryId.id"
          :value="category.productCategoryId.id"
          :text="category.name"
        />
      </vs-select>
    </vs-prompt>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import ProductIcon from "@/assets/images/product-icon.png";
export default {
  data() {
    return {
      moment,
      ProductIcon,

      prompt: false,
      selectedCategory: null,
    };
  },
  props: {
    existingCategories: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapGetters({
      productCategories: "productCategories/productCategories",
    }),
    validForm() {
      return this.selectedCategory != null;
    },

    // Filter out products already in the form
    filteredCategories() {
      return this.productCategories.filter((e) => {
        return !this.existingCategories.some(
          (p) => p.productCategoryId.id === e.productCategoryId.id
        );
      });
    },
  },
  methods: {
    async show() {
      this.prompt = true;
    },
    async accept() {
      this.$emit("categorySelected", this.selectedCategory);
    },
  },
};
</script>

<style lang="scss">
.add-category-popup {
  z-index: 52011;

  .vs-dialog {
    max-width: 400px;

    .vs-dialog-text {
      background-color: #f8f8f8;
    }

    .header-table.vs-table--header {
      margin-left: 0 !important;
    }
  }
}
</style>
